<template>
    <auth-layout :snackbar="snackbar" @snackbar:close="snackbar = null">
        <div class="auth-forgot-password">
            <typo name="title-18-bold">
                {{ dico.lost_password.title }}
            </typo>
            <sep name="M" />
            <v-form class="form" ref="form" v-model="valid" @submit.prevent="submit">
                <text-field
                    required
                    placeholder="Email"
                    v-model="values.loginOrEmail"
                    :rules="[required]"
                />
                <widget-captcha @captcha:done="onCaptchaDone">
                    <div class="buttons">
                        <action
                            name="main"
                            :disabled="isSubmitting || !captcha.isValid"
                            @click="submit"
                        >
                            {{ dico.lost_password.submit_cta }}
                        </action>
                        <v-progress-circular v-if="isSubmitting" indeterminate color="primary" />
                    </div>
                </widget-captcha>
            </v-form>
            <sep name="M" />
            <router-link to="/auth">
                <typo name="body-12-normal" class="link">
                    {{ dico.lost_password.back_cta }}
                </typo>
            </router-link>
        </div>
    </auth-layout>
</template>

<script>
import Vue from "vue";
import AuthLayout from "./AuthLayout.vue";
import TextField from "src/components/common/form/TextField.vue";
import WidgetCaptcha from "src/components/common/captcha/WidgetCaptcha.vue";
import { Services } from "src/services/Services";
import { initialAuthFormData } from "src/utils/auth-form";
import { EventBus } from "src/bus/eventBus";

export default Vue.extend({
    components: {
        AuthLayout,
        TextField,
        WidgetCaptcha,
    },
    data() {
        return {
            ...initialAuthFormData,
            values: {
                loginOrEmail: "",
            },
            captcha: {
                token: null,
                isValid: false,
            },
        };
    },
    computed: {
        dico() {
            return this.$publicDico.login;
        },
    },
    methods: {
        onCaptchaDone(data) {
            this.captcha = {
                token: data.captchaToken,
                isValid: data.isCaptchaValid,
            };
        },
        async submit() {
            this.isSubmitting = this.$refs.form.validate() && this.captcha.isValid;
            if (!this.isSubmitting) {
                return;
            }
            const formValues = { ...this.values, captcha: this.captcha.token };
            try {
                await Services.api.auth.handleForgotPassword(formValues);
                this.snackbar = {
                    text: this.dico.errors["forgot_password_sent_if_email_valid"],
                    color: "success",
                };
            } catch (e) {
                this.snackbar = {
                    text: this.dico.errors["auth_general"],
                    color: "error",
                };
            } finally {
                this.isSubmitting = false;
                EventBus.$emit("captcha:reset");
            }
        },
    },
});
</script>

<style lang="sass" scoped>
.buttons
    display: flex
    align-items: center
    justify-content: space-between
    margin-top: $grid-gutter
    +r(480)
        margin-top: $grid-gutter/2

.form
    width: 400px
    +r(480)
        width: 100%
</style>
